export default __webpack_public_path__ + "img/6735389b0042001ebadab001a4baa640.jpg";